import { emptyContactFlags, IContactFlag, IContactFlags } from 'clickNgo/entities/contactFlag'

export const mapIContactFlagToGroupedContactFlags = (
  contactFlagsData: IContactFlag[]
): IContactFlags => {
  return contactFlagsData.reduce<IContactFlags>((acc, flag) => {
    acc[flag.type].push(flag)
    return acc
  }, emptyContactFlags)
}
